import { NavLink, Link } from "react-router-dom";
import logo from "../../assets/beemz_footer.png";
import googlePlay from "../../assets/play-store.png";
import appstore from "../../assets/app-store.png";
import locationIcon from "../../assets/location_footer.png";
import emailIcon from "../../assets/email_footer.png";
import FreeTrialButton from "../landing/FreeTrialButton";

const Footer = () => {
  return (
    <footer className="relative w-full text-white" style={{ backgroundColor: "#100C17", borderTop: "1px solid rgba(74,68,87,0.2)" }}>
      {/* Main layout */}
      <div className="w-full flex flex-col lg:flex-row justify-between gap-10 px-4 md:px-16 lg:px-20" style={{ paddingTop: "80px", paddingBottom: "48px" }}>

        {/* Left: logo + tagline + description + app badges */}
        <div className="flex flex-col gap-4 lg:w-[35%]">
          <img src={logo} alt="beɘmz" style={{ height: "auto", width: "auto", maxHeight: "48px", objectFit: "contain", objectPosition: "left" }} />
          <p style={{ fontFamily: "Hanken Grotesk, sans-serif", fontWeight: 500, fontSize: "16px", lineHeight: "24px", letterSpacing: "0px", color: "#D1BCFF" }}>
            the out &amp; about chat app
          </p>
          <p className="lowercase" style={{ fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "clamp(14px, 3.5vw, 20px)", lineHeight: "160%", letterSpacing: "0px", color: "#CCC3DA" }}>
            beɘmz has revolutionized restaurant and retail management since 2022, providing commission-free ordering solutions that help small businesses thrive in the digital age.
          </p>
          <div className="flex items-center gap-3 mt-2">
            <a href="https://apps.apple.com/us/app/beɘmz/id1609866877" target="_blank" rel="noopener noreferrer">
              <img src={appstore} alt="App Store" className="h-10 rounded-lg bg-white cursor-pointer hover:scale-105 transition-transform" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.beemxyz&hl=en_IN" target="_blank" rel="noopener noreferrer">
              <img src={googlePlay} alt="Google Play" className="h-12 cursor-pointer hover:scale-105 transition-transform" />
            </a>
          </div>
        </div>

        {/* Middle: quick links */}
        <div className="flex flex-col gap-4 lg:w-[20%]">
          <p className="text-white font-semibold text-lg lowercase" style={{ fontFamily: "Inter, sans-serif" }}>quick links</p>
          <ul className="flex flex-col gap-3">
            {[
              { label: "about us", to: "/aboutus" },
              { label: "pricing", to: "/pricing" },
              { label: "demo", to: "/demo" },
              { label: "contact", to: "/contact" },
              { label: "printing material", to: "/printingmaterial" },
            ].map(({ label, to }) => (
              <li key={to}>
                <NavLink to={to} className={({ isActive }) =>
                  `text-md lowercase transition-colors ${isActive ? "text-white font-medium" : "text-white/70 hover:text-white"}`
                } style={{ fontFamily: "Inter, sans-serif" }}>
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        {/* Right: contact card */}
        <div className="lg:w-[32%] flex flex-col rounded-[48px] gap-4"
          style={{
            backgroundColor: "rgba(33,30,42,0.8)",
            border: "1px solid rgba(209,188,255,0.3)",
            padding: "32px",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
          }}>
          <Link className="lowercase text-lg font-medium" style={{ color: "#9747FF", fontFamily: "Inter, sans-serif" }}>contact</Link>
          <div className="flex flex-col gap-2">
            <h3 className="text-white font-semibold lowercase" style={{ fontFamily: "Inter, sans-serif", fontSize: "22px" }}>ready to get started?</h3>
            <p className="text-white/60 lowercase leading-relaxed" style={{ fontFamily: "Inter, sans-serif", fontSize: "16px" }}>
              transform your restaurant or retail business with beɘmz's all-in-one platform today. free, no risk 30-day trial. cancel anytime.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-2">
              <img src={locationIcon} alt="" style={{ width: "16px", height: "16px", objectFit: "contain", flexShrink: 0 }} />
              <p style={{ fontFamily: "Hanken Grotesk, sans-serif", fontWeight: 400, fontSize: "14px", lineHeight: "20px", letterSpacing: "0px", color: "#E7DFF0" }}>
                Northwall ● Dublin ● Ireland
              </p>
            </div>
            <div className="flex items-center gap-2">
              <img src={emailIcon} alt="" style={{ width: "16px", height: "16px", objectFit: "contain", flexShrink: 0 }} />
              <p style={{ fontFamily: "Hanken Grotesk, sans-serif", fontWeight: 400, fontSize: "14px", lineHeight: "20px", letterSpacing: "0px", color: "#E7DFF0" }}>
                sales@beemxyz.com
              </p>
            </div>
          </div>
          <div className="flex gap-3">
            <button
              onClick={() => window.location.href = "/business/demo"}
              className="flex-1 inline-flex items-center justify-center h-[50px] rounded-full text-white text-sm font-medium lowercase cursor-pointer transition-opacity hover:opacity-80 whitespace-nowrap"
              style={{ border: "1px solid rgba(255,255,255,0.35)", backgroundColor: "transparent", fontFamily: "Inter, sans-serif" }}
            >
              how it works
            </button>
            <FreeTrialButton onClick={() => window.location.href = "/business/get-started"} className="flex-1" />
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="w-full flex flex-col md:flex-row items-start md:items-center justify-between px-4 md:px-16 lg:px-20 pb-8 gap-2">
        <p className="lowercase" style={{ fontFamily: "Hanken Grotesk, sans-serif", fontWeight: 400, fontSize: "14px", lineHeight: "20px", letterSpacing: "0px", color: "#B7B5B4" }}>
          © 2025 beɘmz. all rights reserved. a product of ocisp limited
        </p>
        <div className="flex items-center justify-between w-full md:w-auto gap-6">
          <a href="#" className="lowercase hover:opacity-80 transition-opacity" style={{ fontFamily: "Hanken Grotesk, sans-serif", fontWeight: 400, fontSize: "14px", lineHeight: "20px", letterSpacing: "0px", color: "#B7B5B4" }}>privacy policy</a>
          <a href="#" className="lowercase hover:opacity-80 transition-opacity" style={{ fontFamily: "Hanken Grotesk, sans-serif", fontWeight: 400, fontSize: "14px", lineHeight: "20px", letterSpacing: "0px", color: "#B7B5B4" }}>terms of service</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
